import styled from '@emotion/styled';
import { Box, Button, Tab, Tabs } from '@mui/material';
import { FC, SyntheticEvent, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { removeByIdModAction, updateSortedModAction } from '../../mod.action';
import { getSortedIdsModSelector } from '../../mod.selector';
import { ModType } from '../../mod.types';
import { ModCard } from '../card';
import { RemoveModal } from '../remove-modal';
import { DndModList } from './dnd-list';
import * as R from 'ramda';
import { ModalRemove } from '@/components';

interface ModListProps {
  type: ModType;
}

const Root = styled(Box)({
  // maxWidth: '40rem',
});

export const ModList: FC<ModListProps> = ({ type }) => {
  const dispatch = useDispatch();
  const [tab, setTab] = useState(0);
  const [removeId, setRemoveId] = useState<string | null>(null);
  const mods = useSelector(getSortedIdsModSelector);
  const typeRef = useRef(type);
  const [list, setList] = useState(mods[type]);
  if (typeRef.current !== type) {
    setList(mods[type]);
    typeRef.current = type;
  }
  const handleRemove = (): void => {
    if (removeId) {
      dispatch(removeByIdModAction.started(removeId));
      setRemoveId(null);
      setList(list.filter((id) => id !== removeId));
    }
  };

  const handleTabChange = (_: SyntheticEvent, newTab: number): void => {
    setTab(newTab);
  };

  const updateSorted = (): void => {
    dispatch(updateSortedModAction.started({ type, assetIds: list }));
  };

  const moveItem = (dragIndex: number, hoverIndex: number): void => {
    setList((data) => R.move(dragIndex, hoverIndex, data));
  };

  return (
    <Root>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tab} onChange={handleTabChange} aria-label="basic tabs example">
          <Tab label="Карточки" />
          <Tab label="Таблица (для пересортировки)" />
        </Tabs>
      </Box>
      {tab === 0 ? list.map((modId) => <ModCard key={modId} modId={modId} onRemove={setRemoveId} />) : null}
      {tab === 1 ? (
        <Box>
          <Button onClick={updateSorted}>Сохранить сортировку</Button>
          <DndModList listIds={list} moveItem={moveItem} onRemove={setRemoveId} />
        </Box>
      ) : null}
      {removeId ? (
        <RemoveModal isOpen={!!removeId} modId={removeId} onClose={() => setRemoveId(null)} onRemove={handleRemove} />
      ) : null}
    </Root>
  );
};
